// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SwitchLang_wrapper__2WWpe","link":"SwitchLang_link__3pCxp","active":"SwitchLang_active__17UA2"};